module.exports = "<section-header contents=\"{\n    state: $ctrl.contents.state,\n    iconClass: 'fa-money',\n    title: 'VAT',\n    description: 'Separate VAT from amounts of bank transactions and invoice payments.'\n}\"></section-header> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/5-vat/vat.section-header.html
// module id = 4111
// module chunks = 86